import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import HeroSection from '../components/HeroSection';
import SectionTitle from '../components/SectionTitle';
const AboutDetail = () => {
  const {
    section
  } = useParams<{
    section: string;
  }>();
  const [title, setTitle] = useState('');
  const [subtitle, setSubtitle] = useState('');
  useEffect(() => {
    // Set page title and subtitle based on section
    switch (section) {
      case 'company':
        setTitle('企业介绍');
        setSubtitle('了解我们的企业历程、愿景和使命');
        break;
      case 'team':
        setTitle('团队介绍');
        setSubtitle('认识我们的专业团队，了解他们的专长和经验');
        break;
      case 'culture':
        setTitle('企业文化');
        setSubtitle('探索我们的核心价值观和企业文化');
        break;
      case 'certificates':
        setTitle('资质证书');
        setSubtitle('查看我们的专业资质和认证');
        break;
      case 'join':
        setTitle('加入我们');
        setSubtitle('探索激动人心的职业机会，成为我们团队的一员');
        break;
      case 'contact':
        setTitle('联系我们');
        setSubtitle('获取我们的联系方式，随时与我们沟通');
        break;
      default:
        setTitle('关于我们');
        setSubtitle('了解更多关于我们的信息');
    }
  }, [section]);
  return <div className="bg-white" data-id="element-276">
      <HeroSection title={title} subtitle={subtitle} backgroundImage="https://images.unsplash.com/photo-1573164713988-8665fc963095?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2069&q=80" size="small" data-id="element-277" />
      <section className="py-16" data-id="element-278">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-279">
          <div className="mb-12" data-id="element-280">
            <Link to="/about" className="text-primary-600 hover:text-primary-700 flex items-center" data-id="element-281">
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-282">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" data-id="element-283"></path>
              </svg>
              返回关于我们
            </Link>
          </div>
          <SectionTitle title={title} subtitle={subtitle} data-id="element-284" />
          {/* Content placeholder - would be replaced with actual content for each section */}
          <div className="prose max-w-none" data-id="element-285">
            <p className="text-lg text-gray-700 mb-6" data-id="element-286">
              这里是{title}的详细内容。根据实际需求，这里应该展示与{section}
              相关的具体信息。
            </p>
            <p className="text-lg text-gray-700 mb-6" data-id="element-287">
              在实际开发中，您可以根据不同的section参数值，展示不同的内容组件或从API获取相应的数据。
            </p>
          </div>
        </div>
      </section>
    </div>;
};
export default AboutDetail;